import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {discountsView_template} from "../components/templates/discountsView_template";

declare var ko: any;
declare var page: any;

export class discount_view extends vnModule_knockoutJS {

    protected discountsViewTemplate: discountsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Element[] {
        this.discountsViewTemplate = new discountsView_template("discount_view_template", this.viewModel, this);
        return [this.discountsViewTemplate.build()];
    }

    protected getModuleName(): string {
        return "discount_view";
    }

    fillPage() {
        this.getDiscountDataForView();
    }

    private getDiscountDataForView() {
        this.loadingIn(this.discountsViewTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const discountId = this.getVnAppZone().app.params.discountId;

        const url: string = '/api/discounts/get/' + discountId + '/';
        const request_parameters: string[][] = [];
        request_parameters.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDiscountDataForView;
        this.XHRHdl.execute();
    }

    private onGetDiscountDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.discount) {
                    obj.discountsViewTemplate.setDiscountData(responseParsed.discount);
                }

                obj.loadingOut(obj.discountsViewTemplate.builtTemplate);
            });
        };
    }

    protected onClickEditDiscount(id) {
        const brandId = this.getVnAppZone().app.params.idBrand;
        page("/brand/" + brandId + "/config/discounts/edit/" + id + '/');
    }

    protected onClickCancel() {
        const brandId = this.getVnAppZone().app.params.idBrand;
        page.redirect("/brand/" + brandId + "/config/discounts/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/discount_view.ts